export class ConflictError extends Error {
  constructor(message?: string) {
    super(message || 'Ocorreu um erro');
    this.name = 'ConflictError';
  }
}
